import { createSlice } from '@reduxjs/toolkit';
import { loginThunk, bootstrapAuth } from './authThunks';

const initialState = {
  user: JSON.parse(localStorage.getItem('user')) || null,
  token: localStorage.getItem('accessToken') || null,
  refreshToken: localStorage.getItem('refreshToken') || null,
  loading: false,
  error: null,
  initialised: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout(state) {
      state.user = null;
      state.token = null;
      state.refreshToken = null;
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('user');
      
      // Redirect to login page
      if (typeof window !== 'undefined') {
        window.location.href = '/login';
      }
    },
    setToken(state, action) {
      state.token = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // LOGIN
      .addCase(loginThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.user         = action.payload.user;
        state.token        = action.payload.access;
        state.refreshToken = action.payload.refresh;
      })
      .addCase(loginThunk.rejected, (state, action) => {
        state.loading = false;
        state.error   = action.payload || 'Login failed';
      })

      // BOOTSTRAP
      .addCase(bootstrapAuth.fulfilled, (state, action) => {
        state.user        = action.payload.user;
        state.initialised = true;
      })
      .addCase(bootstrapAuth.rejected, (state) => {
        state.initialised = true;
      });
  },
});

export const { logout, setToken } = authSlice.actions;
export default authSlice.reducer;